import React from "react";
import EnglishData from "../../utils/EkadaData.js";
import { ColorArray } from "../../config/ColorArray";
import SectionDivider from "../../common/SectionDivider";

const EnglishAkdaData = () => {
    return (
            <>
        <SectionDivider title="અંગ્રેજી એકડા" />
        <div className="ekada-grid">
            {EnglishData.map((item, index) => {
                const color = ColorArray[index % ColorArray.length]?.color2;

                return (
                    <div className="ekada-card" key={index}>
                        
                        {/* Number */}
                        <div className="ekada-number" style={{ color }}>
                            {item.english_number}
                        </div>

                        {/* Text Block */}
                        <div className="ekada-text">
                            {/* English Title */}
                            <h2 className="ekada-title" style={{ color }}>
                                {item.english_title}
                            </h2>

                            {/* Gujarati Title */}
                            <p className="ekada-eng" style={{ color }}>{item.gujarati_title}</p>

                            {/* Hindi Title */}
                            <p className="ekada-hindi" style={{ color }}>{item.hindi_title}</p>
                        </div>
                    </div>
                );
            })}
        </div>
        </>
    );
};

export default EnglishAkdaData;
